function Header(){
    return(
        <header>
            <div className="photo"><img src={"https://pbs.twimg.com/profile_images/1489417044122611712/loM44lzK_400x400.jpg"} width="25" height="25" /></div>
            <h1>Hasan Altun</h1>
        </header>
    )
}

export default Header